var _rect, _path, _path2, _path3, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUiUx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 58,
    height: 58,
    rx: 5,
    fill: "#F7971E",
    fillOpacity: 0.15
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M43.1667 35.3752V39.6252C43.1667 41.7502 41.75 43.1668 39.625 43.1668H20.5C21.0808 43.1668 21.6758 43.0818 22.2283 42.8977C22.3842 42.841 22.54 42.7843 22.6958 42.7135C23.1916 42.5152 23.6733 42.2318 24.0983 41.8635C24.2258 41.7643 24.3675 41.6368 24.495 41.5093L24.5516 41.4527L34.185 31.8335H39.625C41.75 31.8335 43.1667 33.2502 43.1667 35.3752Z",
    fill: "#F7971E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M38.0243 27.9942L34.1851 31.8334L24.5518 41.4525C25.5434 40.4325 26.1668 39.03 26.1668 37.5V23.815L30.0059 19.9759C31.5076 18.4742 33.5193 18.4742 35.0209 19.9759L38.0243 22.9792C39.5259 24.4809 39.5259 26.4925 38.0243 27.9942Z",
    fill: "#F7971E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6252 14.8335H18.3752C16.2502 14.8335 14.8335 16.2502 14.8335 18.3752V37.5002C14.8335 37.8827 14.876 38.2652 14.9468 38.6335C14.9893 38.8177 15.0318 39.0018 15.0885 39.186C15.1593 39.3985 15.2302 39.611 15.3152 39.8093C15.3293 39.8235 15.3293 39.8377 15.3293 39.8377C15.3435 39.8377 15.3435 39.8377 15.3293 39.8518C15.5277 40.2485 15.7543 40.631 16.0235 40.9852C16.1793 41.1693 16.3352 41.3393 16.491 41.5093C16.6468 41.6793 16.8168 41.821 17.001 41.9627L17.0152 41.9768C17.3693 42.246 17.7518 42.4727 18.1485 42.671C18.1627 42.6568 18.1627 42.6568 18.1627 42.671C18.3752 42.7702 18.5877 42.841 18.8143 42.9118C18.9985 42.9685 19.1827 43.011 19.3668 43.0535C19.7352 43.1243 20.1177 43.1668 20.5002 43.1668C21.081 43.1668 21.676 43.0818 22.2285 42.8977C22.3843 42.841 22.5401 42.7843 22.696 42.7135C23.1918 42.5152 23.6735 42.2318 24.0985 41.8635C24.226 41.7643 24.3677 41.6368 24.4952 41.5093L24.5518 41.4527C25.5435 40.4327 26.1668 39.0302 26.1668 37.5002V18.3752C26.1668 16.2502 24.7502 14.8335 22.6252 14.8335ZM20.5002 39.6252C19.3243 39.6252 18.3752 38.676 18.3752 37.5002C18.3752 36.3243 19.3243 35.3752 20.5002 35.3752C21.676 35.3752 22.6252 36.3243 22.6252 37.5002C22.6252 38.676 21.676 39.6252 20.5002 39.6252Z",
    fill: "#F7971E"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 57.5,
    height: 57.5,
    rx: 4.75,
    stroke: "#2A85FF",
    strokeOpacity: 0.1,
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUiUx);
export default __webpack_public_path__ + "static/media/ui-ux.d380f50d5387b39b5b5fe2eceac9697a.svg";
export { ForwardRef as ReactComponent };